import { render, staticRenderFns } from "./os-and-version.vue?vue&type=template&id=56aa175e&"
import script from "./os-and-version.vue?vue&type=script&lang=ts&"
export * from "./os-and-version.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports